"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const HashLoader_1 = __importDefault(require("react-spinners/HashLoader"));
const InterviewContext_1 = require("../../../contexts/InterviewContext");
const react_router_1 = require("react-router");
const InterviewsCreateNew = () => {
    const [inProgress, setInProgress] = react_1.default.useState(false);
    const { state, dispatch } = react_1.default.useContext(InterviewContext_1.InterviewContext);
    const navigate = (0, react_router_1.useNavigate)();
    // Function to fetch data from the server, with paging and filtering
    const createUser = react_1.default.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (inProgress || state.status !== 'creating') {
            return;
        }
        // Set in progress state
        setInProgress(true);
        // Make a query string from the filters
        try {
            const response = yield fetch('/api/interviews/createNew', {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                method: 'POST',
                body: JSON.stringify({
                    createUser: state.username,
                    response: state.response
                })
            });
            if (response.status === 200) {
                const jsonData = yield response.json();
                if (jsonData.interviewUuid) {
                    navigate(`/survey/edit/${jsonData.interviewUuid}/`, { replace: true });
                    dispatch({ type: 'success', interviewUuid: jsonData.interviewUuid });
                    return;
                }
                console.log('Server did not return a proper interview id', jsonData);
                // Goto proper error page
            }
            // TODO Go to proper status code page
            console.log('Bad response code from server', response.status);
        }
        catch (error) {
            // TODO Go to proper error page
            console.error(`Error fetching user data from server: ${error}`);
        }
        // Cancel in progress state, only if the page was not redirected
        setInProgress(false);
    }), []);
    react_1.default.useEffect(() => {
        createUser();
    }, []);
    return (react_1.default.createElement("div", { className: "admin" },
        inProgress && react_1.default.createElement(HashLoader_1.default, { size: 30, color: '#aaaaaa', loading: true }),
        !inProgress && 'error'));
};
/** Component used to create new interviews by users other than the main user */
exports.default = InterviewsCreateNew;
//# sourceMappingURL=InterviewsCreateNew.js.map